/** Pasek posiadanych bloków — logika WP7 używa silnika WP0. */
export class BlockPalette {
  constructor(private owned: string[] = []) {}

  setOwned(ids: string[]): void {
    this.owned = [...ids];
  }

  list(): string[] {
    return [...this.owned];
  }

  has(id: string): boolean {
    return this.owned.includes(id);
  }
}
